import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

/**
 * Componente de ruta protegida con validación de roles.
 * Redirige al login si el usuario no está autenticado o no tiene el rol requerido.
 * 
 * @param {Object} props
 * @param {string[]} props.roles - Roles permitidos para acceder a la ruta
 * @param {React.ReactNode} props.children - Componente hijo a renderizar si tiene permiso
 * @returns {JSX.Element} Componente hijo o redirección
 */
export default function ProtectedRoute({ roles, children }) {
  const { user } = useAuth();

  if (!user) return <Navigate to="/login" />;

  if (!roles.includes(user.role)) {
    return <Navigate to="/login" />;
  }

  return children;
}
